module.exports = __webpack_public_path__ + "static/media/beep.b2a5951b.wav";